// @core/api/endpoints/notifications/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CancelNotificationScheduled } from './cancel_notification_scheduled';
import { CreateChannel } from './create_channel';
import { CreateContact } from './create_contact';
import { CreateNotificationScheduled } from './create_notification_scheduled';
import { CreateNotificationTemplate } from './create_notification_template';
import { DeleteChannel } from './delete_channel';
import { DeleteContact } from './delete_contact';
import { DeleteTemplate } from './delete_template';
import { GetChannel } from './get_channel';
import { GetChannelHealth } from './get_channel_health';
import { GetContact } from './get_contact';
import { GetContactByValue } from './get_contact_by_value';
import { GetDeliveryReport } from './get_delivery_report';
import { GetNotification } from './get_notification';
import { GetNotificationStats } from './get_notification_stats';
import { GetTeamMemberOverrides } from './get_team_member_overrides';
import { GetTeamSettings } from './get_team_settings';
import { GetTemplate } from './get_template';
import { GetTenantSettings } from './get_tenant_settings';
import { GetUserSettingsEvent } from './get_user_settings_event';
import { GetUserSettingsGlobal } from './get_user_settings_global';
import { ListChannels } from './list_channels';
import { ListContacts } from './list_contacts';
import { ListContactsByEntity } from './list_contacts_by_entity';
import { ListNotificationTemplates } from './list_notification_templates';
import { ListNotifications } from './list_notifications';
import { ListNotificationsByUser } from './list_notifications_by_user';
import { ListNotificationsScheduled } from './list_notifications_scheduled';
import { ProcessDeliveryConfirmation } from './process_delivery_confirmation';
import { RenderTemplate } from './render_template';
import { SendContactVerification } from './send_contact_verification';
import { SendNotification } from './send_notification';
import { SendNotificationSmart } from './send_notification_smart';
import { SendNotificationsBulk } from './send_notifications_bulk';
import { SetContactPrimary } from './set_contact_primary';
import { SetContactVerified } from './set_contact_verified';
import { SetNotificationRead } from './set_notification_read';
import { SetNotificationsReadAll } from './set_notifications_read_all';
import { TestChannel } from './test_channel';
import { UpdateChannel } from './update_channel';
import { UpdateChannelConfig } from './update_channel_config';
import { UpdateContact } from './update_contact';
import { UpdateTeamMemberOverrides } from './update_team_member_overrides';
import { UpdateTeamSettings } from './update_team_settings';
import { UpdateTemplate } from './update_template';
import { UpdateTenantSettings } from './update_tenant_settings';
import { UpdateUserSettingsEvent } from './update_user_settings_event';
import { UpdateUserSettingsGlobal } from './update_user_settings_global';
import { ValidateChannelConfig } from './validate_channel_config';
import { ValidateContactValue } from './validate_contact_value';

// Re-export individual endpoints
export {
  CancelNotificationScheduled,
  CreateChannel,
  CreateContact,
  CreateNotificationScheduled,
  CreateNotificationTemplate,
  DeleteChannel,
  DeleteContact,
  DeleteTemplate,
  GetChannel,
  GetChannelHealth,
  GetContact,
  GetContactByValue,
  GetDeliveryReport,
  GetNotification,
  GetNotificationStats,
  GetTeamMemberOverrides,
  GetTeamSettings,
  GetTemplate,
  GetTenantSettings,
  GetUserSettingsEvent,
  GetUserSettingsGlobal,
  ListChannels,
  ListContacts,
  ListContactsByEntity,
  ListNotificationTemplates,
  ListNotifications,
  ListNotificationsByUser,
  ListNotificationsScheduled,
  ProcessDeliveryConfirmation,
  RenderTemplate,
  SendContactVerification,
  SendNotification,
  SendNotificationSmart,
  SendNotificationsBulk,
  SetContactPrimary,
  SetContactVerified,
  SetNotificationRead,
  SetNotificationsReadAll,
  TestChannel,
  UpdateChannel,
  UpdateChannelConfig,
  UpdateContact,
  UpdateTeamMemberOverrides,
  UpdateTeamSettings,
  UpdateTemplate,
  UpdateTenantSettings,
  UpdateUserSettingsEvent,
  UpdateUserSettingsGlobal,
  ValidateChannelConfig,
  ValidateContactValue,
};

// Namespace export for convenient usage
export const notificationsApi = {
  CancelNotificationScheduled,
  CreateChannel,
  CreateContact,
  CreateNotificationScheduled,
  CreateNotificationTemplate,
  DeleteChannel,
  DeleteContact,
  DeleteTemplate,
  GetChannel,
  GetChannelHealth,
  GetContact,
  GetContactByValue,
  GetDeliveryReport,
  GetNotification,
  GetNotificationStats,
  GetTeamMemberOverrides,
  GetTeamSettings,
  GetTemplate,
  GetTenantSettings,
  GetUserSettingsEvent,
  GetUserSettingsGlobal,
  ListChannels,
  ListContacts,
  ListContactsByEntity,
  ListNotificationTemplates,
  ListNotifications,
  ListNotificationsByUser,
  ListNotificationsScheduled,
  ProcessDeliveryConfirmation,
  RenderTemplate,
  SendContactVerification,
  SendNotification,
  SendNotificationSmart,
  SendNotificationsBulk,
  SetContactPrimary,
  SetContactVerified,
  SetNotificationRead,
  SetNotificationsReadAll,
  TestChannel,
  UpdateChannel,
  UpdateChannelConfig,
  UpdateContact,
  UpdateTeamMemberOverrides,
  UpdateTeamSettings,
  UpdateTemplate,
  UpdateTenantSettings,
  UpdateUserSettingsEvent,
  UpdateUserSettingsGlobal,
  ValidateChannelConfig,
  ValidateContactValue,
};
